import { render, staticRenderFns } from "./FamilyTable.vue?vue&type=template&id=a397af4e&scoped=true&lang=pug"
import script from "./FamilyTable.vue?vue&type=script&lang=ts"
export * from "./FamilyTable.vue?vue&type=script&lang=ts"
import style0 from "./FamilyTable.vue?vue&type=style&index=0&id=a397af4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a397af4e",
  null
  
)

export default component.exports